import type { SessionView } from "@p0security/shared/integrations/sessions/types";
import type { ExportOption } from "components/Export";
import type { ChangeEvent } from "react";
import { assertNever } from "utils/assert";

import { AuditEventsSessionView } from "./AuditEventsSessionView";
import { CloudAuditSessionView } from "./CloudAuditSessionView";
import { RdpRecordingSessionView } from "./RdpRecordingSessionView";
import { SshSessionEvidenceView } from "./SshSessionEvidenceView";
import { TerminalRecordingSessionView } from "./TerminalRecordingSessionView";

export const SessionViewRouter = ({
  view,
  loading,
  quantity,
  updateQuantity,
  search,
  updateSearch,
  includeResourceSearch,
  updateIncludeResourceSearch,
  getSession,
  exportOptions,
  requestId,
}: {
  view: SessionView;
  loading: boolean;
  quantity: number;
  updateQuantity: (value: number) => void;
  search: string;
  updateSearch: (value: ChangeEvent<HTMLInputElement>) => void;
  includeResourceSearch: boolean;
  updateIncludeResourceSearch: (value: boolean) => void;
  getSession: () => void;
  exportOptions: Record<string, ExportOption<unknown>>;
  requestId: string;
}) => {
  if (view.kind === "cloud-audit") {
    return (
      <CloudAuditSessionView
        view={view}
        loading={loading}
        quantity={quantity}
        updateQuantity={updateQuantity}
        search={search}
        updateSearch={updateSearch}
        includeResourceSearch={includeResourceSearch}
        updateIncludeResourceSearch={updateIncludeResourceSearch}
        getSession={getSession}
        exportOptions={exportOptions}
        requestId={requestId}
      />
    );
  }

  if (view.kind === "terminal-recording") {
    return (
      <TerminalRecordingSessionView
        view={view}
        loading={loading}
        getSession={getSession}
      />
    );
  }

  if (view.kind === "ssh-session-evidence") {
    return (
      <SshSessionEvidenceView
        view={view}
        loading={loading}
        getSession={getSession}
      />
    );
  }

  if (view.kind === "rdp-recording") {
    return (
      <RdpRecordingSessionView
        view={view}
        loading={loading}
        getSession={getSession}
        requestId={requestId}
      />
    );
  }

  if (view.kind === "audit-events") {
    return <AuditEventsSessionView view={view} />;
  }

  assertNever(view);
};
